export default function getGlobalActivityLogsReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_GLOBAL_ACTIVITY_LOGS_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_GLOBAL_ACTIVITY_LOGS_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_GLOBAL_ACTIVITY_LOGS_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}